import { useState } from "react";
import { Scale } from "lucide-react";
import { Link } from "react-router-dom";

const KEY = "faunny_horse_weight";
export const saveHorseWeight = (w) => w && localStorage.setItem(KEY, String(w));

export const DoseByWeight = ({ steps }) => {
  const [w, setW] = useState(localStorage.getItem(KEY) || "500");
  const kg = Math.min(1200, Math.max(80, Number(w) || 0));
  const valid = Number(w) >= 80 && Number(w) <= 1200;
  const change = (v) => { setW(v); if (Number(v) >= 80 && Number(v) <= 1200) saveHorseWeight(v); };
  return (
    <div className="mt-6 rounded border border-[#93C5FD] bg-[#EFF6FF] p-4" data-testid="dose-by-weight">
      <p className="font-display font-bold text-[#0B1D3A] flex items-center gap-2"><Scale size={17} /> Dosis para tu caballo</p>
      <div className="flex items-center gap-2 mt-3">
        <input type="number" min="80" max="1200" value={w} onChange={(e) => change(e.target.value)} data-testid="dose-weight-input"
          className="w-24 h-10 rounded border border-slate-300 px-3 text-sm font-bold focus:border-[#2563EB] outline-none bg-white" />
        <span className="text-sm text-slate-600">kg · <Link to="/peso" className="text-[#2563EB] underline underline-offset-2" data-testid="dose-weight-link">¿No sabes su peso?</Link></span>
      </div>
      {valid ? (
        <ul className="mt-3 space-y-1">
          {steps.map((s) => (
            <li key={s.label} className="flex justify-between gap-3 text-sm" data-testid={`dose-step-${s.label}`}>
              <span className="text-slate-600">{s.label}</span>
              <b className="text-[#DC2626] whitespace-nowrap">{Math.round((s.amount * kg) / 500)} {s.unit}</b>
            </li>
          ))}
        </ul>
      ) : <p className="mt-3 text-sm text-slate-500">Escribe un peso entre 80 y 1200 kg.</p>}
      <p className="text-[11px] text-slate-500 mt-3">Calculado de forma proporcional a la dosis indicada para un caballo de 500 kg. Ante cualquier duda, consulta a tu veterinario.</p>
    </div>
  );
};
